import { Component, Input } from '@angular/core';
import { MainModel } from '../../../models/main';
import { AuthService } from '@auth0/auth0-angular';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../../theme/theme.service';

@Component({
  selector: 'app-nav-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.scss'
})
export class NavBarComponent {
  @Input() vm: MainModel | null = null;

  constructor(private readonly auth: AuthService, private readonly theme: ThemeService) {

  }

  accountAction(vm: MainModel | null) {
    if (!vm?.isAuthenticated) {
      this.auth.loginWithRedirect();
      return;
    }

    this.auth.logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  }

  toggleTheme() {
    this.theme.toggle();
  }
}
